//document.addEventListener('DOMContentLoaded', () => {

//    // helper functions
//    const getCookie = cname => {
//        const name = cname + "=";
//        const ca = document.cookie.split(';');
//        for (let i = 0; i < ca.length; i++) {
//            let c = ca[i];
//            while (c.charAt(0) == ' ') c = c.substring(1);
//            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
//        }
//        return "";
//    }

//    const setCookie = (cname, cvalue, exdays) => {
//        const d = new Date();
//        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//        const expires = "expires=" + d.toUTCString();
//        let cookie = cname + "=" + cvalue + "; path=/;" + expires + ";";

//        if (window.location.hostname.indexOf('rethink.org') !== -1) {
//            cookie += "domain=rethink.org;";
//        }

//        document.cookie = cookie;
//    }

//    const showCookieBanner = () => {
//        cookieBanner.setAttribute('aria-hidden', 'false');
//        cookieBanner.classList.add('is-open');
//    }

//    const hideCookieBanner = () => {
//        cookieBanner.setAttribute('aria-hidden', 'true');
//        cookieBanner.classList.remove('is-open');
//    };

//    const rethinkCookiePolicy = "Rethink_Cookie_Policy";
//    const cookieDetails = getCookie(rethinkCookiePolicy);
//    const cookieBanner = document.querySelector('#cookieBanner');


//    // cookie banner control
//    if (cookieBanner !== null && cookieDetails === "") {
//        const cookieBannerBtns = cookieBanner.querySelectorAll('button');

//        window.setTimeout(showCookieBanner, 1500);

//        Array.prototype.forEach.call(cookieBannerBtns, cookieBannerBtn => {
//            cookieBannerBtn.addEventListener('click', () => {
//                var cookieAcceptance = '';
//                if (cookieBannerBtn.dataset.id === "mandatory") {
//                    //mandatory = 1
//                    cookieAcceptance = '1';
//                    setCookie(rethinkCookiePolicy, "1", 365);
//                } else {
//                    //all cookies = 2
//                    cookieAcceptance = '2';
//                    setCookie(rethinkCookiePolicy, "2", 365);
//                }

//                if (window.dataLayer) {
//                    window.dataLayer.push({ 'rethinkCookieAcceptanceValue': cookieAcceptance });
//                    window.dataLayer.push({ 'event': 'RethinkCookiePolicyUpdated' });
//                }

//                hideCookieBanner();
//            });
//        });
//    }


//    // cookie settings page
//    const settingSwitch = document.querySelector('#otherCookiesCheckbox');
//    const settingText = document.querySelector('#other-checkbox-text');
//    const saveBtn = document.querySelector('#saveSettingsBtn');

//    if (settingSwitch !== null) {

//        const setConsentTrue = () => {
//            settingSwitch.checked = true;
//            settingText.innerHTML = "All cookies";
//            saveBtn.setAttribute('data-consent', '2');
//        }

//        const setConsentFalse = () => {
//            settingSwitch.checked = false;
//            settingText.innerHTML = "All mandatory cookies";
//            saveBtn.setAttribute('data-consent', '1');
//        }

//        // check for cookie status on page load and set initial switch position and text
//        if (cookieDetails === "2") {
//            setConsentTrue();
//        } else {
//            setConsentFalse();
//        }

//        // save settings
//        const saveSettings = event => {
//            const consent = event.target.dataset.consent;
            
//            if (consent === '2') {
//                setCookie(rethinkCookiePolicy, "2", 365);
            
//            } else {
//                // expire all cookies
//                document.cookie.split(";").forEach(function (c) {
//                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
//                });

//                setCookie(rethinkCookiePolicy, "1", 365);
//            }

//            if (window.dataLayer) {
//                window.dataLayer.push({ 'rethinkCookieAcceptanceValue': consent });
//                window.dataLayer.push({ 'event': 'RethinkCookiePolicyUpdated' });
//            }

//            // reload page to refresh updated cookies
//            window.location.reload(true);
//        };

//        settingSwitch.addEventListener('change', () => {
//            if (settingSwitch.checked === true) {
//                setConsentTrue();
//            } else {
//                setConsentFalse();
//            }
//        });

//        saveBtn.addEventListener('click', event => {
//            saveSettings(event);
//        });
//    }
//});

